import { BorderRadius, Color, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  card: {
    width: '100%',
    padding: Spacing.S12,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: Color.Grey200,
    borderRadius: BorderRadius.R8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: Spacing.S8,
  },
})
